import { SxProps } from '@mui/material';
import zeplinColor from 'theme/Color';

const styles: Record<string, SxProps> = {
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '15px',
    gap: '20px',
    backgroundColor: zeplinColor.Neutral1,
    border: `1px solid ${zeplinColor.Neutral5}`,
    borderRadius: '14px',
    width: '100%',
    textDecoration: 'none',
    color: zeplinColor.BasicBlack,
  },
  header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' },
  metaData: { display: 'flex', gap: '12px' },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '54px',
    aspectRatio: '54px',
    overflow: 'hidden',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    justifyContent: 'space-between',
  },
  chipsContainer: { display: 'flex', gap: '8px' },
  chip: {
    textTransform: 'capitalize',
    height: '22px',
    '& .MuiChip-label': {
      padding: '4px 8px',
    },
  },
  chipPrimary: { backgroundColor: zeplinColor.BasicBlack, color: zeplinColor.Neutral1 },
  chipSecondary: { backgroundColor: zeplinColor.Neutral4, color: zeplinColor.BasicBlack },
  widgetContainer: { display: 'flex', gap: '12px' },
  widget: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    gap: '6px',
    padding: '8px',
    borderRadius: '8px',
    backgroundColor: zeplinColor.Neutral3,
    width: '100%',
  },
  contactContainer: { display: 'flex', justifyContent: 'space-between' },
  contact: { display: 'flex', alignItems: 'center', gap: '4px' },
  links: { display: 'flex', alignItems: 'center', gap: '16px' },
  logo: {
    width: '52px',
    height: '52px',
  },
  optionMenu: {
    padding: '3px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    ':hover': {
      backgroundColor: zeplinColor.Neutral5,
      cursor: 'pointer',
    },
  },
};

export const primary = { ...styles.chip, ...styles.chipPrimary };
export const secondary = { ...styles.chip, ...styles.chipSecondary };

export default styles;
